const t = "Popover'a gitmek için Tab tuşuna basın", i = {
  triggerHint: t
};
export {
  i as default,
  t as triggerHint
};
